import React from "react";
import { motion } from "framer-motion";
import img from "../../../assets/FOTO/IMG_7180.JPG";

const KombinezonMain = () => {
  return (
    <section className="bg-[#f5ebdc] text-[#313131] p-8 flex flex-col md:flex-row items-center">
      {/* Tekst po lewej stronie */}
      <div className="flex-1 mb-8 md:mb-0 md:pr-8">
        <motion.h2
          className="text-5xl font-bold mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          CZYM SIĘ RÓŻNI EMS U NAS?
        </motion.h2>
        <motion.p
          className="text-lg mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Zapewne trening EMS kojarzysz z kamizelkami, które się moczy przed
          treningiem, nakładając je na ciało jest.. zimno i mokro do tego
          dochodzą kable, które czasem są, czasem nie... ale zawsze to
          ograniczają ruch. Mało przyjemnie brzmi, prawda?
        </motion.p>
        <motion.p
          className="text-lg mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          U nas wygląda to inaczej, dzięki najnowszemu sprzętowi na polskim
          rynku:
        </motion.p>
        <ul className="list-disc list-inside mb-4">
          <motion.li
            className="text-md"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            Kostium jest bez kabli i ograniczających ruch kamizelek - dzięki
            temu czujesz się lekko i trenowanie jest przyjemniejsze.
          </motion.li>
          <motion.li
            className="text-md"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            Nie moczymy stroju, więc jest suchy, a nakładając go nie odczuwasz
            zimna.
          </motion.li>
          <motion.li
            className="text-md"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.0 }}
          >
            Każdy strój jest prany i dezynfekowany po każdej osobie. Masz
            pewność, że wcześniej nie pocił się w nim ktoś inny. Nie dostaniesz
            kostiumu po osobie, która trenowała przed Tobą.
          </motion.li>
        </ul>
        <motion.p
          className="text-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.2 }}
        >
          Całkowicie inne uczucie, prawda?
        </motion.p>

        {/* Przycisk do zapisania się */}
        <div className="text-center mt-6">
          <motion.a
            href="/pierwsza-wizyta"
            className="inline-block bg-orange-500 text-white py-2 px-4 rounded hover:bg-orange-700 transition duration-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.5 }}
          >
            Zapisz się na pierwsze zajęcia
          </motion.a>
        </div>
      </div>

      {/* Obraz po prawej stronie */}
      <div className="flex-1">
        <motion.img
          src={img}
          alt="Kombinezon EMS"
          className="w-full h-auto rounded-lg shadow-lg"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        />
      </div>
    </section>
  );
};

export default KombinezonMain;
